export default "__VITE_ASSET__DRJJBxZR__"